'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FloatBanner = function () {
  function FloatBanner(element) {
    _classCallCheck(this, FloatBanner);

    this.banner = element;
    this.closeButton = element.querySelector('.js-float-banner_close');
    this.closeButton.addEventListener('click', this.hideBanner.bind(this));
  }

  // バナーを非表示にするメソッド


  _createClass(FloatBanner, [{
    key: 'hideBanner',
    value: function hideBanner() {
      this.banner.classList.add('is-hidden');
    }
  }]);

  return FloatBanner;
}();

document.addEventListener('DOMContentLoaded', function () {
  var floatBanners = document.querySelectorAll('.js-float-banner');
  floatBanners.forEach(function (element) {
    new FloatBanner(element);
  });

  var footer = document.querySelector('.js-footer');
  var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      floatBanners.forEach(function (banner) {
        if (entry.isIntersecting) {
          banner.classList.add('is-off');
        } else {
          banner.classList.remove('is-off');
        }
      });
    });
  }, observerOptions);

  observer.observe(footer);
});